//------------------------------------
// reset skill adj totals and reasons
//------------------------------------
export default function resetSkillAdjTotalsReasons(skill) {

  if (!skill) {
    console.error('resetSkillAdjTotalsReasons: missing required parms')
    return skill
  }

  skill.adjs_tot = 0
  skill.adjs_tot_character_skill = 0
  skill.adjs_tot_characteristic_skill = 0
  skill.adjs_tot_integrated_rune_skill = 0
  skill.adjs_reasons_character_skill = ''
  skill.adjs_reasons_character_skill_opt = ''
  skill.adjs_reasons_characteristic_skill = ''
  skill.adjs_reasons_integrated_rune_skill = ''

  return skill

}
